<template>
  <div class="activation">
    <div class="activation-title">激活码</div>
    <div class="activation-code">
      <input type="text" v-model="activationCode" />
      <button @click="onSave">保存到本地</button>
    </div>
    <div class="activation-tips">复制激活码到软件内激活</div>
    <div class="activation-tips">
      保存到本地：将以txt文件保存至本地，文件名为“小咪隐私空间激活码”
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    activationCode: '',
  }),
  methods: {
    onSave() {
      var a = document.createElement('a')
      a.href = window.URL.createObjectURL(
        new Blob([this.activationCode], { type: 'text/plain' })
      )
      a.download = '小咪隐私空间激活码.txt'
      a.click()
    },
  },
  mounted() {
    this.activationCode = this.$route.query.code
  },
}
</script>

<style lang='scss' scoped>
.activation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  .activation-title {
    font-size: 18px;
    margin-bottom: 20px;
    &::before {
      content: '*';
      display: inline-block;

      color: #ff578e;
    }
  }
  .activation-code {
    margin-bottom: 20px;
    input {
      width: 380px;
      height: 36px;
      padding: 0 10px;
      border: 1px solid #263737;
      border-radius: 8px;
      font-family: Consolas, monospace;
    }
    button {
      font-size: 14px;
      color: #193032;
      margin-left: 10px;
      border: none;
      background-color: transparent;
      cursor: pointer;
      &:hover {
        color: #24ecd9;
      }
    }
  }
  .activation-tips {
    margin-bottom: 20px;
    color: #193032;
    opacity: 0.6;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
